// import React, { useState, useRef, useEffect } from "react";

// function CreatePurchaseOrders() {

//   return (
//     <>
//      <div>
//         Hello
//      </div>
//     </>
//   );
// }

// export default CreatePurchaseOrders;

import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../../common/Toast";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import Select from "react-select";
import NewWorkModal from "../../../components/Modal/NewWorkModal";

import { uploadAWS } from "../../../common/AWSHelper";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_SALES,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";

const CreatePurchaseOrders = (props) => {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [SecondCategories, setSecondCategories] = useState([]);
  const [selectedCategory, setselectedCategory] = useState({ value: 0 });

  const [SecondCriteria, setSecondCriteria] = useState([]);
  const [SelectedCriteria, setSelectedCriteria] = useState();

  const [supplierValue, setsupplierValue] = useState();
  const [supplierID, setSupplierID] = useState(0);

  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  // const [Criteria, setCriteria] = useState(0);

  const token = localStorage.getItem("Token");

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  const handleCategoryChanged = (event) => {
    console.log("Event  ==>", event);
    let categoryID = 0;
    if (event != null) {
      setselectedCategory(event);
      categoryID = event.value;
    } else {
      setselectedCategory({ name: "", value: 0 });
    }
  };

  let itemCriteria = [];
  const ItemCriteria = SecondCriteria.map((u, i) => {
    itemCriteria[i] = { label: u.Name, value: u.Id };
  });


console.log( itemCriteria , "itemCriteria=>" )

  const handleCriteriaChanged = (event) => {
    console.log("Event  ==>", event);
    let CriteriaID = 0;
    if (event != null) {
      setSelectedCriteria(event);
      CriteriaID = event.value;
    } else {
      setSelectedCriteria({ name: "", value: 0 });
    }
  };

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
  }));

  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };

  // const selectStyles = {
  //     control: (provided) => ({
  //         ...provided,
  //         width: "100%",
  //         height: "40px",
  //         position: "relative",
  //     }), // dropdown input css
  //     menu: () => ({
  //         boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //         position: "absolute",
  //         background: "#f8f8f8",
  //         width: "100%",
  //         zIndex: 99,
  //     }), // dropdown menu css
  // };

  // Categorie Dropdown API
  const categoriesAPI = (CategorieData) => {
    //API
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);

        // if (CategorieData != undefined) {
        //   let CategorieList = res.data.ResponseData;
        //   CategorieList.map((selectedCategory) => {
        //     if (selectedCategory.ID == CategorieData) {
        //       setselectedCategory({
        //         label: selectedCategory.Name,
        //         value: selectedCategory.ID,
        //       });
        //     }
        //   });
        // }
      });
  };
  useEffect(() => {
    categoriesAPI();

    // Supplier Dropdown API
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    // item Criteria API

    axios
    .get(`${config.receivingBaseUrl}/Receivings/ItemSearchCriteria`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        Authorization: token,
      },
    })
    .then((response) => {
      console.log("Item Criteria", response.data.ResponseData);
      // setCriteria(response.data.ResponseData);
      setSecondCriteria(response.data.ResponseData);
    })
    .catch((error) => {
      console.log(error);
    });

  }, []);
  

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Receiving </h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/Receiving">Receiving</Link>
                </li>
                <li className="breadcrumb-item">Create Purchase Order</li>
              </ul>
            </div>
          </div>
          <div className="btn-group ms-2 mb-2 pull-right">
            <button
              type="button"
              className="btn btn-sm btn-outline-dark d-none"
            >
              More
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{ borderRadius: "5px" }}
            >
              More &nbsp;
              {/* <span className="sr-only">Toggle Dropdown</span> */}
            </button>
            <div className="dropdown-menu">
              <li>
                <Link class="dropdown-item" to="/sales">
                  New Sale
                </Link>
              </li>
              <li>
                {/* <Link class="dropdown-item"
                                    to="/workorders"
                                    // title="Cleanup old Customers"
                                    data-bs-target="#NewWorkModal"
                                    data-bs-toggle="modal"
                                    onClick={() => navigate('/workorders')}
                                >

                                    New Work Order
                                </Link> */}
              </li>
              <li>
                <Link class="dropdown-item" to="/create-purchase-orders">
                  New Purchase Order
                </Link>
              </li>
              <li>
                <Link class="dropdown-item" to="/manage-suppliers">
                  New Supplier
                </Link>
              </li>
              <li>
                <Link to="/manage-items" className="dropdown-item">
                  New Item
                </Link>
              </li>
            </div>
          </div>
          <form>
            {/* {divs} */}
            <div className="card mt-5">
              <div className="card-body">
                <div className="col-sm-12 mb-2">
                  <div className="row">
                    <label className="col-form-label col-md-3 form-label">
                      Supplier:
                    </label>
                    <div className="col-md-9">
                      <Select
                        defaultValue={supplierValue}
                        onChange={(event) => {
                          handleChangeSupplier(event);
                        }}
                        options={supplierDropDown}
                        placeholder="Supplier"
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 mb-2">
                  <div className="row">
                    <label className="col-form-label col-md-3 form-label">
                      Category:
                    </label>
                    <div className="col-md-9">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        // onChange={setselectedCategory}
                        onChange={(e) => setselectedCategory(e)}
                        options={Catagories}
                        placeholder="Categories"
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={
                          Catagories.find(
                            (option) =>
                              option?.value === selectedCategory?.value
                          ) || ""
                        }
                        id="Category"
                        name="Category"
                        className="w-100 custom-search-select"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <div className="row">
                    <label className="col-form-label col-md-3 form-label">
                      Criteria For Purchase Order:
                    </label>
                    <div className="col-md-9">
                    <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        options={itemCriteria}
              
                        onChange={(e) => setSelectedCriteria(e)}
                        placeholder="Criteria For Purchase Order"
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={
                          itemCriteria.find(
                            (option) => 
                            option?.value === SelectedCriteria?.value
                          )
                        }
                        id="CriteriaForPurchaseOrder"
                        name="CriteriaForPurchaseOrder"
                        className="w-100 custom-search-select"
                      />
                      
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-2">
                  <div className="form-group row">
                    <label className="col-form-label col-md-3 form-label">
                      Clear Current Items In Cart:{" "}
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-check-input"
                        style={{ width: "1.5em", height: "1.5em" }}
                        type="checkbox"
                        id="ClearCurrentItemsInCart"
                        name="ClearCurrentItemsInCart"
                        // onChange={handleChange}
                        // onInput={handleSelectOverrideDefaultTaxForSale}
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-sm btn-primary mb-3 me-3 pull-right"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <NewWorkModal />
    </>
  );
};

export default CreatePurchaseOrders;
